// extracted by mini-css-extract-plugin
export default {"MainCont":"Chilling_MainCont__5dyf0","RightCont":"Chilling_RightCont__eMsFs"};